<template>
    <c-dialog ref="dialog" mode="slide" width="80vw" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">
        <c-form ref="form" column="3" vertical unit-width="100%">
            <c-form link-parent>
                <c-title>服务工单</c-title>
                <c-form-item label="关联售后工单" required>
                    <c-select v-model="orderId" ref="orderSelect" name="order_id" async :disabled="id>0" :clear="false" @search="searchOrder"></c-select>
                    <info-card code="AFTERSALE_ORDER" :id="orderId"></info-card>
                </c-form-item>
                <c-form-item label="售后申请单">
                    <c-input name="aftersale_apply_no" type="text" :disabled="true"></c-input>
                </c-form-item>
                <c-form-item label="售后网点">
                    <c-input name="after_sale_outlet_name" type="text" :disabled="true"></c-input>
                </c-form-item>
                <c-form-item label="实际售后网点">
                    <c-select name="actual_outlet_id" :options="outletOptions" :clear="false" @change="onActualOutletChange"></c-select>
                    <template #tip>
                        仅用于界面计算公里数（往返）用，默认与工单售后网点一致
                    </template>
                </c-form-item>
<!--                <c-form-item label="起始地址">-->
<!--                    <c-input name="start_address" type="textarea" maxlength="500"></c-input>-->
<!--                </c-form-item>-->
                <c-form-item label="客户地址">
                    <c-input name="customer_address" type="textarea" maxlength="500"></c-input>
                </c-form-item>
                <c-form-item label="城市">
                    <c-input name="city" maxlength="100"></c-input>
                </c-form-item>
                <c-form-item label="销售部门编号">
                    <c-input name="sale_dept_code" type="text"></c-input>
                </c-form-item>
                <c-form-item label="公里数(往返)">
                    <c-input name="kilometers" type="number" decimal="2" :range="[0,Infinity]" append-text="公里" @change="recalculateFees"></c-input>
                </c-form-item>
                <c-form-item label="人员到达时间（实际最早到达日期）">
                    <c-datetime name="arrive_time" type="date"></c-datetime>
                </c-form-item>
                <c-form-item label="是否收费" required>
                    <c-select name="is_charge" :options="isChargeDic"></c-select>
                </c-form-item>
                <c-form-item label="是否派车" required>
                    <c-select name="is_send_car" :options="isChargeDic" @change="recalculateFees"></c-select>
                </c-form-item>
                <c-form-item label="是否使用机台" required>
                    <c-select name="is_use_machine" :options="isChargeDic" @change="recalculateFees"></c-select>
                </c-form-item>
                <c-form-item label="是否完成" required>
                    <c-select name="is_finish" :options="isChargeDic"></c-select>
                </c-form-item>
                <c-title>服务内容</c-title>
                <c-form-item label="服务内容" colspan="3">
                    <c-input type="textarea" name="service_content" maxlength="1000" :rows="4"></c-input>
                </c-form-item>
                <c-form-item label="备注" colspan="3">
                    <c-input type="textarea" name="remark" maxlength="500" :rows="4"></c-input>
                </c-form-item>
                <c-title>费用计算</c-title>
                <c-form-item label="正常日天数" required>
                    <c-input name="normal_days" type="stepper" decimal="1" :range="[0,Infinity]" append-text="天" @change="recalculateFees"></c-input>
                    <template #tip>
                        默认取值：工单创建时根据填写的服务天数、开始日期及节假日表计算出的正常日天数
                    </template>
                </c-form-item>

                <c-form-item label="休息日天数">
                    <c-input name="holiday_days" type="stepper" decimal="1" :range="[0,Infinity]" append-text="天" @change="recalculateFees"></c-input>
                    <template #tip>
                        默认取值：工单创建时根据填写的服务天数、开始日期及节假日表计算出的休息日天数
                    </template>
                </c-form-item>
                <c-form-item label="节日天数">
                    <c-input name="festival_days" type="stepper" decimal="1" :range="[0,Infinity]" append-text="天" @change="recalculateFees"></c-input>
                    <template #tip>
                        默认取值：工单创建时根据填写的服务天数、开始日期及节假日表计算出的节日天数
                    </template>
                </c-form-item>
                <c-form-item label="住宿天数" required>
                    <c-input name="accommodation_days" type="stepper" decimal="1" :range="[0,Infinity]" append-text="晚" @change="recalculateFees"></c-input>
                    <template #tip>
                        默认取值：工单创建时填写的住宿天数
                    </template>
                </c-form-item>
                <c-form-item label="服务人数" required>
                    <c-input name="service_people_count" type="stepper" decimal="0" :range="[0,Infinity]" append-text="人" @change="recalculateFees"></c-input>
                    <template #tip>
                        默认取值：工单实际服务人数
                    </template>
                </c-form-item>
                <c-form-item label="交通费">
                    <c-input name="traffic_fee" type="number" decimal="2" :range="[0,Infinity]" append-text="元" @change="recalculateTotalFees"></c-input>
                </c-form-item>
                <c-form-item label="车辆费用" required>
                    <c-input name="vehicle_fee" type="number" decimal="2" :range="[0,Infinity]" append-text="元" @change="recalculateTotalFees"></c-input>
                    <template #tip>
                        默认取值：工单预估成本中的车辆费用，含交通费
                    </template>
                </c-form-item>
                <c-form-item label="设备费用" required>
                    <c-input name="machine_fee" type="number" decimal="2" :range="[0,Infinity]" append-text="元" @change="recalculateTotalFees"></c-input>
                    <template #tip>
                        默认取值：工单预估成本中的设备费用
                    </template>
                </c-form-item>
                <c-form-item label="员工费用" required>
                    <c-input name="staff_fee" type="number" decimal="2" :range="[0,Infinity]" append-text="元" @change="recalculateTotalFees"></c-input>
                    <template #tip>
                        默认取值：工单预估成本中的员工费用
                    </template>
                </c-form-item>
                <c-form-item label="总金额" required>
                    <c-input name="total_amount" type="number" decimal="2" :range="[0,Infinity]" append-text="元"></c-input>
                    <template #tip>
                        默认取值：工单预估成本总额
                    </template>
                </c-form-item>
                <c-form-item label="通知单金额">
                    <c-input name="notice_amount" type="number" decimal="2" :range="[0,Infinity]" append-text="元"></c-input>
                    <template #tip>
                        默认取值：售后申请单的预估收费金额
                    </template>
                </c-form-item>
                <c-form-item label="上门服务人员费用">
                    <c-input name="onsite_service_fee" type="number" decimal="2" :range="[0,Infinity]" append-text="元"></c-input>
                    <template #tip>
                        默认取值：工单报销总金额
                    </template>
                </c-form-item>

            </c-form>

            <c-title>上门服务记录单明细</c-title>
            <c-form-item :label="false" name="item_list" colspan="3" >
                <c-table ref="itemListTable" border :paging="false" :data="itemList" :disabled="isResubmit">
                    <c-table-column label="产品编码" width="100">
                        <template #default="{data}">
                            <span>{{data.product_code || '-'}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="规格型号" width="120">
                        <template #default="{data}">
                            <span>{{data.spec_model || '-'}}</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="接头方式" width="100">
                        <template #default="{data, index}">
                            <c-select :options="connectionMethodDic" v-model="itemList[index].connection_method" type="text" :disabled="isResubmit"></c-select>
                        </template>
                    </c-table-column>
                    <c-table-column label="长(mm)" width="80">
                        <template #default="{data, index}">
                            <c-input v-model="itemList[index].length" type="number" decimal="2" :range="[0,Infinity]" :disabled="isResubmit"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="宽(mm)" width="80">
                        <template #default="{data, index}">
                            <c-input v-model="itemList[index].width" type="number" decimal="2" :range="[0,Infinity]" :disabled="isResubmit"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="平方米" width="80">
                        <template #default="{data, index}">
                            <c-input v-model="itemList[index].quantity" type="number" decimal="2" :range="[0,Infinity]" :disabled="isResubmit"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="件数" width="80">
                        <template #default="{data, index}">
                            <c-input v-model="itemList[index].pieces" type="number" decimal="2" :range="[0,Infinity]" :disabled="isResubmit"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                            type="button"
                            label="操作"
                            width="200"
                            button-limit="4"
                    >
                        <template #default="{data, index}">
                            <c-table-button icon="tf-trash" @click="removeRecordItem(index)" :disabled="isResubmit">删除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </c-form-item>
            <c-title>上门服务人员</c-title>
            <c-form-item :label="false" name="member_list" colspan="3" >
                <c-table ref="memberListTable" border :paging="false" :data="memberList" >
                    <c-table-column label="服务人员" width="80">
                        <template #default="{data, index}">
                            <c-input v-model="memberList[index].user_realname" type="text" :disabled="isResubmit"></c-input>
                        </template>
                    </c-table-column>
                    <c-table-column label="费用" width="120">
                        <template #default="{data, index}">
                            <c-input v-model="memberList[index].fee" type="number" decimal="2" :range="[0,Infinity]" append-text="元" :disabled="isResubmit"></c-input>
                        </template>
                    </c-table-column>

                    <c-table-column
                            type="button"
                            label="操作"
                            width="200"
                            button-limit="4"
                    >
                        <template #default="{data, index}">
                            <c-table-button icon="tf-trash" @click="removeMemberItem(index)" :disabled="isResubmit">删除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
            </c-form-item>
        </c-form>

        <template #button>
            <c-button size="form" v-if="!isResubmit" color="primary" @click="submitHandle(-1)">暂存草稿</c-button>
            <c-button size="form" color="main" @click="submitHandle(2)">确认提交</c-button>
        </template>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'visitServiceEdit',

    props: {
        id: Number,
        isResubmit: Boolean,
    },

    data() {
        return {
            orderId: '',
            orderData: {},
            itemList: [],
            memberList: [],
            outletOptions: [],
            outletMap: {},
            customerLng: '',
            customerLat: '',
            pendingActualOutletId: '',
        }
    },

    computed: {
        ...mapState(['isChargeDic', 'connectionMethodDic']),
    },

    watch: {
        orderId(val) {
            if (val && !this.id) {
                this.$refs.form.clear();
                this.itemList= [];
                this.memberList= [];
                this.request({
                    url: '/after/sale/order/service_detail',
                    data: {
                        id: val
                    },
                    success: ({detailInfo, itemList, memberList}) => {
                        this.orderData = detailInfo;
                        this.$refs.form.set({
                            aftersale_apply_no: detailInfo.aftersale_apply_no || '',
                            after_sale_outlet_name: detailInfo.after_sale_outlet_name || '',
                            start_address: detailInfo.after_sale_outlet_address || '',
                            customer_address: detailInfo.customer_address || '',
                            city: detailInfo.city_name || '',
                            kilometers: (detailInfo.customer_distance || 0) *2,
                            arrive_time: detailInfo.arrival_time || '',
                            is_charge: detailInfo.is_charge || 2,
                            is_send_car: detailInfo.is_send_car || 2,
                            is_use_machine: detailInfo.use_machine || 2,
                            is_finish: detailInfo.is_finish || 2,
                            service_days: detailInfo.estimated_service_days || 0,
                            normal_days: detailInfo.normal_days || 0,
                            holiday_days: detailInfo.weekend_days || 0,
                            festival_days: detailInfo.holiday_days || 0,
                            accommodation_days: detailInfo.accommodation_days || 0,
                            vehicle_fee: detailInfo.car_fee || 0,
                            machine_fee: detailInfo.machine_fee || 0,
                            staff_fee: detailInfo.staff_fee || 0,
                            total_amount: detailInfo.estimated_cost_total || 0,
                            service_content: detailInfo.demand_description || '',
                            service_people_count: detailInfo.actual_technician_count || 0,
                            onsite_service_fee: detailInfo.reimbursement_amount || 0,
                            notice_amount: detailInfo.estimated_fee || 0,
                        });
                        // 记录工单位置坐标，默认实际网点=工单售后网点，加载网点下拉用于距离重算
                        this.customerLng = detailInfo.customer_address_longitude || '';
                        this.customerLat = detailInfo.customer_address_latitude || '';
                        this.pendingActualOutletId = detailInfo.after_sale_outlet_id ? String(detailInfo.after_sale_outlet_id) : '';
                        this.loadOutlets();
                        this.itemList = (itemList || []).map(
                                item => ({
                                    product_code: item.product_code,
                                    spec_model: item.spec_model,
                                    length: item.length,
                                    width: item.width,
                                    pieces: item.pieces,
                                    quantity: item.quantity,
                                    connection_method: item.connection_method || '',
                                    item_remark: item.item_remark || '',
                                    inventory_name: item.inventory_name || '',
                                    inventory_code: item.inventory_code || '',
                                })
                        );
                        this.memberList = (memberList || []).map(
                                item => ({
                                    order_member_id: item.id,
                                    user_id: item.user_id,
                                    user_realname: item.user_realname,
                                    fee: item.fee,
                                })
                        );
                    }
                });
            } else {
                this.orderData = {};
            }
        }
    },

    methods: {
        open() {
            this.orderId = '';
            this.orderData = {};
            this.itemList= [];
            this.$refs.form.clear();
            this.memberList = [];
            this.customerLng = '';
            this.customerLat = '';
            this.outletOptions = [];
            this.outletMap = {};
            this.pendingActualOutletId = '';
            if (this.id) {
                this.request({
                    url: '/aftersale/visit_service/detail',
                    data: {
                        id: this.id
                    },
                    success: ({detailInfo, itemList, memberList}) => {
                        this.$refs.form.set(detailInfo);
                        // 回显：坐标来自关联工单；实际上门网点不落库，默认取工单售后网点（仅供距离重算）
                        this.customerLng = detailInfo.customer_address_longitude || '';
                        this.customerLat = detailInfo.customer_address_latitude || '';
                        this.pendingActualOutletId = detailInfo.after_sale_outlet_id ? String(detailInfo.after_sale_outlet_id) : '';
                        this.loadOutlets();
                        this.$refs.orderSelect.setValueData([{
                            name: `${detailInfo.order_number} | ${detailInfo.customer_name}`,
                            value: detailInfo.order_id
                        }]);
                        this.itemList = itemList.map(
                                item => ({
                                    id: item.id,
                                    product_code: item.product_code,
                                    spec_model: item.spec_model,
                                    length: item.length,
                                    width: item.width,
                                    pieces: item.pieces,
                                    quantity: item.quantity,
                                    connection_method: item.connection_method || '',
                                    item_remark: item.item_remark || '',
                                    inventory_name: item.inventory_name || '',
                                    inventory_code: item.inventory_code || '',
                                })
                        );
                        this.memberList = (memberList || []).map(
                                item => ({
                                    id: item.id,
                                    service_record_id: item.service_record_id,
                                    order_member_id: item.order_member_id,
                                    user_id: item.user_id,
                                    user_realname: item.user_realname,
                                    fee: item.fee ,
                                })
                        );
                    }
                });
            }

            this.$refs.dialog.open({
                title: this.id ? '编辑上门服务记录单' : '创建上门服务记录单'
            });
        },

        searchOrder(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'AFTERSALE_ORDER',
                    is_visit_service_record: 1,
                    status:[5],
                    keyword: keyword
                },
                success: data => {
                    resolve(data.map(item => {
                        return {
                            name: `${item.data.order_number} | ${item.data.customer_name}`,
                            value: item.data.id,
                            data: item.data
                        }
                    }));
                }
            })
        },

        submitHandle(status) {
            let submitUrl = this.id ? '/aftersale/visit_service/edit' : '/aftersale/visit_service/add';
            if(this.isResubmit){
                submitUrl = '/aftersale/visit_service/resubmit';
            }
            this.$refs.form.submit({
                url: submitUrl,
                rule: {
                    order_id: '请选择关联售后工单',
                    is_charge: '请选择是否收费',
                    is_send_car: '请选择是否派车',
                    is_use_machine: '请选择是否使用机台',
                    is_finish: '请选择是否完成',
                    accommodation_days: '请填写住宿天数',
                    normal_days: '请填写正常服务天数',
                    service_people_count: '请填写服务人数',
                    vehicle_fee: '请填写车辆费用',
                    machine_fee: '请填写设备费用',
                    staff_fee: '请填写员工费用',
                    total_amount: '请填写总费用',
                },
                dataFormatter: data => {
                    data.id = this.id;
                    // 实际上门服务网点仅供界面重算距离，不落库（公里数才是真正持久化的字段）
                    data.traffic_fee = data.traffic_fee || 0;
                    data.holiday_days = data.holiday_days || 0;
                    data.festival_days = data.festival_days || 0;
                    data.service_days = parseFloat(data.normal_days) + parseFloat(data.holiday_days) + parseFloat(data.festival_days);
                    data.status = status;
                    data.item_list = this.itemList;
                    data.member_list = this.memberList;
                    return data;
                },
                success: () => {
                    this.$message({
                        message: '提交成功'
                    });
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                }
            })
        },
        removeRecordItem(index) {
            this.itemList.splice(index, 1);
        },
        removeMemberItem(index) {
            this.memberList.splice(index, 1);
        },
        recalculateFees() {
            const formData = this.$refs.form.get();

            this.request({
                url: '/aftersale/fee_config/calc_fee',
                data: {
                    kilometers: parseFloat(formData.kilometers) || 0,
                    is_use_machine: formData.is_use_machine,
                    is_send_car: formData.is_send_car,
                    normal_days: parseFloat(formData.normal_days) || 0,
                    holiday_days: parseFloat(formData.holiday_days) || 0,
                    festival_days: parseFloat(formData.festival_days) || 0,
                    accommodation_days: parseFloat(formData.accommodation_days) || 0,
                    service_people_count: parseInt(formData.service_people_count) || 0
                },
                success: data => {
                    this.$refs.form.set({
                        vehicle_fee: data.vehicle_fee || 0,
                        machine_fee: data.machine_fee || 0,
                        staff_fee: data.staff_fee || 0
                    });
                    this.recalculateTotalFees();
                },
                error: () => {
                    this.$message.error('费用计算失败，请稍后重试');
                }
            });
        },
        recalculateTotalFees() {
            const formData = this.$refs.form.get();
            const trafficFee = parseFloat(formData.traffic_fee) || 0;
            const vehicleFee = parseFloat(formData.vehicle_fee) || 0;
            const machineFee = parseFloat(formData.machine_fee) || 0;
            const staffFee = parseFloat(formData.staff_fee) || 0;
            const totalAmount = (trafficFee + vehicleFee + machineFee + staffFee).toFixed(2);

            this.$refs.form.set({
                total_amount: totalAmount
            });
        },
        // 加载启用中的售后网点下拉，并缓存各网点坐标（用于距离重算）
        loadOutlets() {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'AFTERSALE_OUTLET'
                },
                success: list => {
                    this.outletOptions = (list || []).map(item => ({ name: item.name, value: item.value }));
                    this.outletMap = {};
                    (list || []).forEach(item => {
                        const d = item.data || {};
                        this.outletMap[item.value] = {
                            name: item.name,
                            longitude: d.longitude,
                            latitude: d.latitude
                        };
                    });
                    // 下拉就绪后，将实际网点值统一为字符串并默认回填（历史空值回退工单售后网点）
                    const cur = this.$refs.form.get().actual_outlet_id;
                    const target = cur ? String(cur) : (this.pendingActualOutletId || '');
                    if (target) {
                        this.$refs.form.set({ actual_outlet_id: target });
                    }
                }
            });
        },
        // 实际上门服务网点变化：按“工单位置↔所选网点”重算单程距离→往返公里数→联动费用
        onActualOutletChange() {
            const formData = this.$refs.form.get();
            const outlet = this.outletMap[formData.actual_outlet_id];
            if (!outlet || !outlet.longitude || !outlet.latitude) {
                return;
            }
            if (!this.customerLng || !this.customerLat) {
                this.$message({
                    message: '未获取到工单位置坐标，无法计算距离',
                    type: 'warning'
                });
                return;
            }
            this.request({
                url: '/location/distance',
                data: {
                    longitude1: outlet.longitude,
                    latitude1: outlet.latitude,
                    longitude2: this.customerLng,
                    latitude2: this.customerLat
                },
                success: data => {
                    // /location/distance 返回单程公里数，往返按 ×2 口径
                    const roundTrip = (parseFloat(data.distance) || 0) * 2;
                    this.$refs.form.set({ kilometers: roundTrip });
                    this.recalculateFees();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
